// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.step-order-kS8rzB{background:var(--light-color-brand-brand-5,#4d53e8);width:16px;height:16px;color:var(--light-color-white-white,#fff);border-radius:50%;justify-content:center;align-items:center;margin-top:2px;font-size:10px;font-weight:600;display:flex}.step-title-fbaFcC{color:#000;margin-bottom:8px;font-size:14px;font-weight:600;line-height:22px}.markdown-ihOOii{color:var(--light-usage-text-color-text-0,#1d1c23);font-size:14px;line-height:22px}.link-area-yqpTLT .link-list-hCIt6h{margin-top:16px}.link-area-yqpTLT .link-list-hCIt6h .title-HQq6si{color:var(--light-usage-text-color-text-0,#1d1c23);font-size:14px;font-weight:600;line-height:22px}.link-area-yqpTLT .link-list-hCIt6h .link-zMA1OB{word-break:break-word}.link-area-yqpTLT .link-list-hCIt6h .semi-form-field-error-message-ig2k1h{position:absolute}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"step-order": `step-order-kS8rzB`,
	"stepOrder": `step-order-kS8rzB`,
	"step-title": `step-title-fbaFcC`,
	"stepTitle": `step-title-fbaFcC`,
	"markdown": `markdown-ihOOii`,
	"link-area": `link-area-yqpTLT`,
	"linkArea": `link-area-yqpTLT`,
	"link-list": `link-list-hCIt6h`,
	"linkList": `link-list-hCIt6h`,
	"title": `title-HQq6si`,
	"link": `link-zMA1OB`,
	"semi-form-field-error-message": `semi-form-field-error-message-ig2k1h`,
	"semiFormFieldErrorMessage": `semi-form-field-error-message-ig2k1h`
};
export default ___CSS_LOADER_EXPORT___;
